import { useEffect, useState } from 'react';

interface propsExamSessionValidation {
  isEdited: boolean;
  isAdd: boolean;
  inputValue: string;
  data: string;
  verificationApi: (value: string) => Promise<boolean>;
  onBlur: boolean;
}

function useExamSessionValidation({
  isEdited,
  isAdd,
  inputValue,
  data,
  verificationApi,
  onBlur,
}: propsExamSessionValidation) {
  const [isValidValue, setIsValidValue] = useState<boolean>(true);

  useEffect(() => {
    if (isEdited) {
      if (isAdd) {
        if (inputValue) {
          if (!inputValue.trim().length) {
            setIsValidValue(false);
          } else {
            setIsValidValue(true);
          }
        } else {
          setIsValidValue(false);
        }
      } else {
        if (inputValue === data || inputValue.trim().length) {
          setIsValidValue(true);
        } else {
          setIsValidValue(false);
        }
      }
    } else {
      setIsValidValue(true);
    }
  }, [inputValue, data, isAdd, isEdited, verificationApi]);

  useEffect(() => {
    if (isEdited && inputValue.trim().length && onBlur) {
      if (isAdd) {
        verificationApi(inputValue).then((result) => {
          setIsValidValue(result);
        });
      } else {
        if (data !== inputValue) {
          verificationApi(inputValue).then((result) => {
            setIsValidValue(result);
          });
        }
      }
    }
  }, [onBlur, isEdited, inputValue, data, verificationApi]);

  return { isValidValue };
}

export default useExamSessionValidation;
